import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ObjectFieldEntity } from './object-field.entity';

@Index(
	'_object_field_select_options__fk__object_field__id_value_unique',
	['fkObjectFieldId', 'value'],
	{ unique: true },
)
@Entity('_object_field_select_options')
export class ObjectFieldSelectOptionsEntity extends BaseEntity {
	@Column('int', {
		name: '_fk__object_field__id',
		nullable: true,
		unsigned: true,
	})
	public fkObjectFieldId!: number | null;

	@Column('varchar', { name: 'value', nullable: true, length: 255 })
	public value!: string | null;

	@Column('varchar', { name: 'text', nullable: true, length: 255 })
	public text!: string | null;

	@Column('varchar', { name: 'subtext', nullable: true, length: 255 })
	public subtext!: string | null;

	@ManyToOne(
		() => ObjectFieldEntity,
		(objectField) => objectField.objectFieldSelectOptions,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([{ name: '_fk__object_field__id', referencedColumnName: 'id' }])
	public fkObjectField!: ObjectFieldEntity;
}
